// extracted by mini-css-extract-plugin
export var eventsSection = "events-module--eventsSection--N7Y5C";